import { render, staticRenderFns } from "./MenuSon.vue?vue&type=template&id=3384d629&"
import script from "./MenuSon.vue?vue&type=script&lang=js&"
export * from "./MenuSon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports